const CRAPI_URL = 'https://cr-api.etp-proto0.com'
const CRAPI_AUTH_ID = process.env.GATSBY_DEV_CRAPI_AUTH_ID || ''
const CR_ETP_URL = 'https://dev.crunchyroll.com'
const SEGMENT_HOST = 'cr-eec.etp-proto0.com/v1'
const FALLBACK_SEGMENT_HOST = 'sa.etp-proto0.com/analytics.js/v1/'
const COOKIE_DOMAIN = '.etp-proto0.com'
const SSO_URL = 'https://sso.dev.crunchyroll.com'
const AVATARS_STATIC_URL = 'https://static.etp-proto0.com'
const NEWSAPI_URL = 'https://cr-news-api-service.stg.crunchyrollsvc.com/v1'
const ENV = 'proto0'

export default {
  env: ENV,
  domain: CR_ETP_URL,
  crApiUrl: CRAPI_URL,
  crApiAuthId: CRAPI_AUTH_ID,
  crEtpUrl: CR_ETP_URL,
  cookieDomain: COOKIE_DOMAIN,
  segment: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
  },
  segmentGen2: {
    segmentHost: SEGMENT_HOST,
    fallbackLibraryHost: FALLBACK_SEGMENT_HOST,
  },
  ssoUrl: SSO_URL,
  avatarsStaticUrl: AVATARS_STATIC_URL,
  newsApiUrl: NEWSAPI_URL,
}
